export default __webpack_public_path__ + "static/media/car-parking.fc13b2d5.png";